var render, staticRenderFns
import script from "./eb-icon.vue?vue&type=script&lang=js&"
export * from "./eb-icon.vue?vue&type=script&lang=js&"
import style0 from "./eb-icon.vue?vue&type=style&index=0&id=54563ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54563ae8",
  null
  
)

export default component.exports